export enum ModelNodeLabelEnum {
  FilterOnlyFields = 'Filter-only fields',
  Dimensions = 'Dimensions',
  Measures = 'Measures',
  Calculations = 'Calculations'
}
